import { render, staticRenderFns } from "./giftcard-dialog.vue?vue&type=template&id=6cbfeb24&scoped=true&"
import script from "./giftcard-dialog.vue?vue&type=script&lang=js&"
export * from "./giftcard-dialog.vue?vue&type=script&lang=js&"
import style0 from "./giftcard-dialog.vue?vue&type=style&index=0&id=6cbfeb24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cbfeb24",
  null
  
)

export default component.exports